import styled from "@emotion/styled";
import { TextField } from "@mui/material";
import theme from "../../Theme";
export const CustomTextField = styled(TextField)({
    // backgroundColor: "#031A3A",
  borderRadius: "16px",
  border: `3px solid ${theme.palette.secondary.main}`,
  color: `${theme.palette.secondary.main}`,

  "& input, & textarea": {
    color: `${theme.palette.text.primary}`,
    // fontsize:".8rem !important",
    textAlign: "right",
    "&::placeholder": {
      color: `${theme.palette.text.primary}`,
      opacity: 0.5,
      fontSize:".8rem"
    },
  },

  "& fieldset": {
    border: "none",
  },

  "&.Mui-focused": {
    border: `1px solid #f29999ff`,
  },
});
